/**
 * Shared flow configuration for BioTemplatePremium routes.
 * Keep production and test routes in sync from one source.
 */

import {
  buildStripeSuccessReturnRelative,
  type PostPaymentLanguage,
} from "@/lib/muchasGraciasSuccessUrl";

export type PremiumCurrency = "ARS" | "USD";

export const PREMIUM_INVITE_FLOW_NAME = "premium_invite";
export const PREMIUM_WEBSITE_FLOW_NAME = "premium_website";

const SUCCESS_ARS = "/ar/invitacion/success";

/**
 * Stripe USD: post-pago va a `/portal/completar-perfil` (es) o
 * `/portal/complete-profile` (en). Se calcula por idioma para que los visitantes
 * en inglés vean URLs en inglés a lo largo del embudo.
 */
function successUsdForLanguage(language?: PostPaymentLanguage): string {
  return buildStripeSuccessReturnRelative(language);
}

export function getPremiumInvitePaths(
  currency: PremiumCurrency,
  language?: PostPaymentLanguage,
): {
  successPath: string;
  cancelPath?: string;
} {
  return {
    successPath:
      currency === "ARS" ? SUCCESS_ARS : successUsdForLanguage(language),
    // Matches Index production route behavior.
    cancelPath: currency === "USD" ? "/" : undefined,
  };
}

export function getPremiumWebsitePaths(
  currency: PremiumCurrency,
  language?: PostPaymentLanguage,
): {
  successPath: string;
  cancelPath?: string;
} {
  return {
    successPath:
      currency === "ARS" ? SUCCESS_ARS : successUsdForLanguage(language),
    cancelPath: currency === "USD" ? "/invitacion-premium" : undefined,
  };
}
